<script>
  import Wrapper from "./components/layout/wrapper.svelte";
  import { Router } from "svelte-router-spa";
  import { routes } from "./routes";
  import { theme } from "./stores/store";
</script>

{#if $theme === "dark"}
  <style lang="scss">
    body {
      background: $dark;
    }
  </style>
{:else}
  <style lang="scss">
    body {
      background: $light;
    }
  </style>
{/if}

<svelte:head>
  <link rel="icon" type="image/png" href="favicon.png" />
  <title>Retale.me - Beautiful Quotes to Share</title>
  <meta
    name="description"
    content="Random quotes, displayed beautifully, shared easily."
  />
  <link rel="preconnect" href="https://fonts.gstatic.com" />
  <link
    href="https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,700;1,400&display=swap"
    rel="stylesheet"
  />
  <script
    rel="preload"
    src="https://kit.fontawesome.com/41e1df4ff0.js"
    crossorigin="anonymous"></script>
</svelte:head>

<div class="theme {$theme}">
  <Wrapper>
    <Router {routes} />
  </Wrapper>
</div>

<style global>
  @import "src/styles/globalStyles.scss";
  @import "src/styles/theme.scss";
  @import "src/styles/media.scss";
  @import "bulma/sass/utilities/_all.sass";
  @import "bulma/sass/helpers/flexbox.sass";
  @import "bulma/sass/helpers/visibility.sass";
</style>
